var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.33,0.15c0.31,0 0.62,0 0.93,0c3.56,1.89 5.53,4.85 5.89,8.87c-1.25,0.09 -2.49,0 -3.71,-0.31c-0.54,-2.41 -1.93,-4.14 -4.19,-5.19c0.18,-1.16 0.54,-2.28 1.08,-3.37z",
    fill: "none",
    id: "svg_2",
    opacity: 0.9,
    stroke: "#bfbfbf",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25,8.62c0,-0.31 0,-0.61 0,-0.91c1.98,-3.62 5.08,-5.56 9.29,-5.8c0,1.22 0,2.44 0,3.67c-1.23,0.08 -2.35,0.44 -3.4,1.08c-1.11,0.95 -2.04,2.01 -2.78,3.21c-0.97,-0.57 -2,-0.99 -3.09,-1.22l-0.01,-0.01l-0.01,-0.01l0,-0.01z",
    fill: "none",
    id: "svg_4",
    opacity: 0.88,
    stroke: "#bfbfbf",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20,11.16c0,0.31 0,0.61 0,0.91c-2.08,3.47 -5.18,5.41 -9.29,5.8c-0.05,-1.22 0,-2.44 0.15,-3.67c2.68,-0.61 4.65,-2.14 5.89,-4.58c1.11,0.48 2.18,0.99 3.25,1.53l0,0.01z",
    fill: "none",
    id: "svg_6",
    opacity: 0.88,
    stroke: "#bfbfbf",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.99,10.68c1.24,0 2.48,0 3.71,0c0.54,2.62 1.98,4.61 4.34,5.95c-0.47,1.09 -1,2.17 -1.55,3.21c-4,-1.8 -6.19,-4.85 -6.51,-9.17l0.01,0l0,0.01z",
    fill: "none",
    id: "svg_8",
    opacity: 0.89,
    stroke: "#bfbfbf",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.cc02fafd.svg";
export { ForwardRef as ReactComponent };